import { render, staticRenderFns } from "./delayed.vue?vue&type=template&id=72bbd7da"
import script from "./delayed.vue?vue&type=script&lang=js"
export * from "./delayed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports